import { abPauseSubscription } from 'reactApp/appHelpers/featuresHelpers/features/pauseSubscription';
import {
    closePauseSubscriptionDialog,
    renderPauseSubscriptionDialog,
} from 'reactApp/components/PauseSubscriptionDialog/PauseSubscriptionDialog.helpers';
import { BuySubscriptionActions, BuySubscriptionSelectors } from 'reactApp/modules/buySubscription/buySubscription.module';
import type { OutflowOfferMobileProps, OutflowOfferWebProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { store } from 'reactApp/store';
import { select } from 'typed-redux-saga';

export function* checkPauseOffer() {
    const canPauseSubscription = yield* select(BuySubscriptionSelectors.getCanPauseSubscription);
    return canPauseSubscription && abPauseSubscription;
}

export function* pauseOffer({ subscription, continueOutflow, cancelOutflow }: OutflowOfferWebProps) {
    yield renderPauseSubscriptionDialog({
        subscription,
        onAction() {
            closePauseSubscriptionDialog();
            continueOutflow();
        },

        onClose() {
            closePauseSubscriptionDialog();
            cancelOutflow();
        },
        onSuccess() {
            store.dispatch(
                BuySubscriptionActions.pauseSubscription({
                    subscriptionId: subscription.id,
                    period: abPauseSubscription,
                })
            );
            closePauseSubscriptionDialog();
            cancelOutflow();
        },
    });
}

export function* pauseOfferMobile(props: OutflowOfferMobileProps) {
    yield pauseOffer(props);
}
